import { FullScreenSpinner } from "~/v2/components/common";
import { useWithdrawController } from "./Withdraw.controller";
import { WithdrawPresentation } from "./Withdraw.pres";

export const WithdrawConnector = () => {
  const { isLoading, ...presentationProps } = useWithdrawController();

  if (isLoading) {
    return <FullScreenSpinner />;
  }

  return <WithdrawPresentation {...presentationProps} />;
};
